import { customFetch } from '#/services/customFetch'
import type { Category } from '../types/course.types'

export async function getCategories(): Promise<Category[]> {
  return customFetch<Category[]>('/student/categories')
}
